import { GroupRowType, GroupTableType, LayerGroupType } from "helpers/models";
import fathomArray from "report/common/sort-lable-fathom";
import sortLayerBottom from "./sort-layer-bottom";

export default (group: GroupTableType, legend: LayerGroupType) => {
  for (const layerId in group) {
    const layer = group[layerId];

    const otherArray = sortLayerBottom(Object.keys(legend[layerId]).reverse());
    const orderArray = layerId.includes("Fathom") ? fathomArray : otherArray;

    layer.sort((a: GroupRowType, b: GroupRowType) => {
      return orderArray.indexOf(a.label) - orderArray.indexOf(b.label);
    });
  }
};
